import React, { useState, forwardRef } from "react";
import { InputText } from "primereact/inputtext";
import { InputNumber } from "primereact/inputnumber";
import { Dropdown } from "primereact/dropdown";
import { CombineDateTime } from "../../../../utils/dates";
import teachersAPI from "../../../../services/teachers";
import scheduleAPI from "../../../../services/schedule";
import classroomsAPI from "../../../../services/classrooms";
import MeaCreateModal from "../../../../components/MeaCreateModal";
import sessionsAPI from "../../../../services/sessions";
import { Calendar } from "primereact/calendar";

const CreateSessionModal = forwardRef((props, ref) => {
  //
  const accessToken = "";
  const { schoolId, trainingId } = props;
  //const timezone = authContext?.currentMembership?.school?.timezone;
  const timezone = "Europe/Paris";
  //
  const [scheduleItem, setScheduleItem] = useState("-1");
  const [teacher, setTeacher] = useState("-1");
  const [classroom, setClassroom] = useState("-1");
  const [day, setDay] = useState("");
  const [startHour, setStartHour] = useState("");
  const [endHour, setEndHour] = useState("");
  const [points, setPoints] = useState(0);

  // Schedule items (programmations)
  const scheduleList = scheduleAPI.useGetList(
    schoolId,
    trainingId,
    accessToken,
    1,
    100000
  );
  const uniqueScheduleItems = scheduleList.data?.data || [];
  const scheduleItems = uniqueScheduleItems.map((item) => ({
    key: item.id,
    label:
      (item.classe?.name || "") +
      " / " +
      (item.course?.name || "") +
      (item.slot?.name ? " (" + item.slot.name + ")" : ""),
    value: item.id,
  }));
  scheduleItems.sort((a, b) => a.label.localeCompare(b.label));
  const selectedScheduleItem = uniqueScheduleItems.find(
    (item) => item.id === scheduleItem
  );

  // Teachers
  const teachersList = teachersAPI.useGetList(
    schoolId,
    trainingId,
    accessToken,
    1,
    100000
  );
  const uniqueTeachers = teachersList.data?.data || [];
  uniqueTeachers.sort((a, b) => a.member.lastname - b.member.lastname);
  const teachers = uniqueTeachers.map((teacher, index) => ({
    key: teacher.id,
    label: teacher.member.lastname + " " + teacher.member.firstname,
    value: teacher.id,
  }));
  teachers.unshift({
    key: "empty-teacher-key",
    label: "",
    value: "",
  });
  // Classroom
  const classroomsList = classroomsAPI.useGetList(
    schoolId,
    trainingId,
    accessToken,
    1,
    100000
  );
  const uniqueClassrooms = classroomsList.data?.data || [];
  uniqueClassrooms.sort((a, b) => a.name - b.name);
  const classrooms = uniqueClassrooms.map((classroom, index) => ({
    key: classroom.id,
    label: classroom.name,
    value: classroom.id,
  }));
  classrooms.unshift({
    key: "empty-classroom-key",
    label: "",
    value: "",
  });
  //
  const onScheduleItemChange = (value) => {
    setScheduleItem(value);
    const item = uniqueScheduleItems.find((element) => element.id === value);
    if (item) {
      setTeacher(item.teacher_id || "-1");
      setClassroom(item.classroom_id || "-1");
      setStartHour(item.start_hour || item.slot?.start_hour || "");
      setEndHour(item.end_hour || item.slot?.end_hour || "");
      setPoints(item.points ?? 0);
    }
  };
  //
  return (
    <>
      <MeaCreateModal
        ref={ref}
        title="Créer une session"
        serviceAPI={sessionsAPI}
        accessToken={accessToken}
        schoolId={schoolId}
        trainingId={trainingId}
        data={{
          schedule_item_id: scheduleItem === "-1" ? "" : scheduleItem,
          teacher_id: teacher === "-1" ? "" : teacher,
          classroom_id: classroom === "-1" ? "" : classroom,
          start_date: CombineDateTime(day, startHour),
          end_date: CombineDateTime(day, endHour),
          points: points ?? 0,
        }}
      >
        <label htmlFor="programmation" className="block text-900 font-medium mb-2">
          Programmation
        </label>
        <Dropdown
          id="programmation"
          options={scheduleItems}
          value={scheduleItem || "-1"}
          onChange={(e) => onScheduleItemChange(e.value)}
          optionLabel="label"
          optionValue="value"
          filter
          placeholder="Choisir une programmation"
          className="w-full mb-3"
        />

        <label htmlFor="jour" className="font-medium text-900">Jour</label>
        <Calendar locale="fr" value={day ? new Date(day) : null} onChange={(e) => setDay(e.value)} dateFormat="dd/mm/yy" id="jour" showIcon />

        <div className="card flex flex-column md:flex-row gap-3">
          <div className="p-inputgroup flex flex-column gap-2">
            <label
              htmlFor="heureDebut"
              className="block text-900 font-medium mb-2"
            >
              Heure de début
            </label>
            <InputText
              id="heureDebut"
              type="time"
              value={startHour}
              onChange={(e) => setStartHour(e.target.value)}
              className="w-full mb-3"
            />
          </div>
          <div className="p-inputgroup flex flex-column gap-2">
            <label
              htmlFor="heureFin"
              className="block text-900 font-medium mb-2"
            >
              Heure de fin
            </label>
            <InputText
              id="heureFin"
              type="time"
              value={endHour}
              onChange={(e) => setEndHour(e.target.value)}
              className="w-full mb-3"
            />
          </div>
        </div>
        <small>
          Les heures doivent correspondre au fuseau horaire de l'école (
          {timezone})
        </small>

        <div className="card flex flex-column md:flex-row gap-3">
          <div className="p-inputgroup flex flex-column gap-2">
            <label htmlFor="classe" className="block text-900 font-medium mb-2">
              Classe
            </label>
            <InputText
              id="classe"
              value={selectedScheduleItem?.classe?.name || ""}
              className="w-full mb-3"
              disabled={true}
            />
          </div>
          <div className="p-inputgroup flex flex-column gap-2">
            <label htmlFor="cours" className="block text-900 font-medium mb-2">
              Matière
            </label>
            <InputText
              id="cours"
              value={selectedScheduleItem?.course?.name || ""}
              className="w-full mb-3"
              disabled={true}
            />
          </div>
        </div>

        <div className="card flex flex-column md:flex-row gap-3">
          <div className="p-inputgroup flex flex-column gap-2">
            <label
              htmlFor="enseignant"
              className="block text-900 font-medium mb-2"
            >
              Enseignant(e)
            </label>
            <Dropdown
              id="enseignant"
              options={teachers}
              value={teacher || "-1"}
              onChange={(e) => setTeacher(e.value)}
              optionLabel="label"
              optionValue="value"
              placeholder="Select a Teacher"
              className="w-full mb-3"
            />
          </div>
          <div className="p-inputgroup flex flex-column gap-2">
            <label htmlFor="salle" className="block text-900 font-medium mb-2">
              Salle
            </label>
            <Dropdown
              id="salle"
              options={classrooms}
              value={classroom || "-1"}
              onChange={(e) => setClassroom(e.value)}
              optionLabel="label"
              optionValue="value"
              placeholder="Select a Classroom"
              className="w-full mb-3"
            />
          </div>
        </div>

        <label htmlFor="points" className="block text-900 font-medium mb-2">
          Points
        </label>
        <InputNumber
          id="points"
          value={points}
          onValueChange={(e) => setPoints(e.value ?? 0)}
          mode="decimal"
          minFractionDigits={0}
          maxFractionDigits={2}
          min={0}
          className="w-full mb-1"
        />
        <small className="text-600">
          Points attribués à cette séance (initialisés depuis la programmation).
        </small>
      </MeaCreateModal>
    </>
  );
});

export default CreateSessionModal;
